import clsx from 'clsx';

export default function Skeleton({
  className,
}: {
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'animate-pulse rounded-md bg-secondary/40 ring-1 ring-inset ring-accent/35',
        className,
      )}
      aria-hidden
    />
  );
}

